// extracted by mini-css-extract-plugin
module.exports = {"container":"TestimonialReview_container__sN9DX","user_name":"TestimonialReview_user_name__7N4lY","stars":"TestimonialReview_stars____ibe","text":"TestimonialReview_text__6o0d1"};